import { useTranslations } from '@vocab/react';
import type { TranslationKeys } from '@vocab/core';
import translations from './.vocab';

interface Option {
  label: string;
  value: string;
}

type translationKeys = TranslationKeys<typeof translations>;

const labelNameToKeyMap: Record<string, translationKeys> = {
  year: 'Year label',
  month: 'Month label',
};

export const useTimeInRole = () => {
  const { t } = useTranslations(translations);

  const populateTimeInRoleOptions = (
    maxCount: number,
    label: 'year' | 'month',
    canBeMore = false,
  ): Option[] => {
    const arr = [];
    let i;
    let translatedLabel;
    const translationKey = labelNameToKeyMap[label];

    for (i = 0; i <= maxCount; i++) {
      if (!label) {
        translatedLabel = `${i}`;
      } else if (canBeMore && i === maxCount) {
        translatedLabel = t('Year label with max count', { labelCount: i });
      } else {
        translatedLabel = t(translationKey, { labelCount: i });
      }
      arr.push({ label: translatedLabel, value: `${i}` });
    }
    return arr;
  };

  const getTimeInRole = (
    timeInRoleYears: string | undefined,
    timeInRoleMonths: string | undefined,
  ) => {
    const arr: any[] = [];
    if (timeInRoleYears) {
      arr.push(t('Year label', { labelCount: Number(timeInRoleYears) }));
    }
    if (timeInRoleMonths) {
      arr.push(t('Month label', { labelCount: Number(timeInRoleMonths) }));
    }

    return arr.join(', ');
  };
  return {
    getTimeInRole,
    populateTimeInRoleOptions,
  };
};

export default useTimeInRole;
